import React, { useMemo, useState } from 'react';
import { ByTypeSelectType, MentionsSentimentTabType } from '../../../constants';
import { gameInfoType } from '@op/types/common';
import {
  getTableColumns,
  SentimentMentionsTwoLevelType,
  starIconList,
} from '../utils';
import TableCommonHook from '@op/components/TableCommonHook';
import { getStarIcon } from '@op/utils/text';
import { useIntl } from 'umi';
import { AnalysisSummaryTypeTab } from '@op/pages/Summary/KeywordAndURLAnalysis/types';

export default function SentimentMentionsTable({
  tab,
  gameInfo,
  by_type,
  metrics,
  filter,
  records = [],
  height = 340,
}: {
  tab: MentionsSentimentTabType | AnalysisSummaryTypeTab;
  gameInfo: gameInfoType;
  by_type: ByTypeSelectType;
  metrics: SentimentMentionsTwoLevelType | SentimentMentionsTwoLevelType[];
  filter: any;
  records: Array<any>;
  height?: number;
}) {
  const { formatMessage } = useIntl();
  const tableColumns = useMemo(() => {
    const columns = getTableColumns({
      currentTab: tab,
      gameInfo,
      by_type,
      metrics,
      filter,
    });

    return columns.map((item) => {
      const { header, key } = item;
      const isStar = starIconList.includes(header);
      return {
        ...item,
        header: isStar
          ? getStarIcon(Number(header))
          : formatMessage({ id: header }),
      };
    });
  }, [tab, by_type, metrics, formatMessage]);

  return (
    <TableCommonHook
      recordKey={'key'}
      columns={tableColumns}
      total={records.length}
      records={records}
      hasPageable={false}
      maxHeight={height}
      minWidth={tableColumns.length > 4 ? undefined : 'auto'}
    />
  );
}
